import MarketRegionState from "../market_area/MarketAreaState";
import MarketInsightMarketArea from './MarketInsightMarketArea';

export default class MarketInsight {
	marketRegionStates: MarketRegionState[];
	totalMarketRegionStates: number
	// The region of the hotel and its market areas (the market tabs); one entry = a region with one market.
	marketRegionName: string | null;
	marketAreas: MarketInsightMarketArea[];

	constructor(data: MarketInsight) {
		Object.assign(this, data);
	}

	public findMarketAreaStateByStatDate(statDate: string): MarketRegionState | undefined {
		return this.marketRegionStates.find(state => state.statDate === statDate);
	}
}